import type { FDI_Notation } from '@common/FDI_Notation';

export const WIDE_TEETH_FDI: FDI_Notation[] = [
  38, 37, 36, 35, 34, 44, 45, 46, 47, 48, // lower jaw (adult)
  18, 17, 16, 15, 14, 13, 11, 21, 23, 24, 25, 26, 27, 28, // upper jaw (adult)
];

export const MID_TEETH_FDI: FDI_Notation[] = [
  31, 32, 33, 41, 42, 43, // lower jaw (adult)
  12, 22, // upper jaw (adult)
];
